import { toJS } from 'mobx'
import { type IResponseFilterSmartView } from 'entities/SmartViews/api/types'

export type IItemData = {
  contactIds: number[]
  inboxIds: number[]
  userIds: number[]
  tagIds: number[]
}

const getValueByKey = (key: string, data: IItemData) => {
  if (key === 'conversations.user_id') return data.userIds
  if (key === 'conversations.contact_id') return data.contactIds
  if (key === 'conversations.team_id') return data.inboxIds
  if (key === 'tag') return data.tagIds

  return []
}

export const checkFilterSmartView = (data: IItemData, filtersGroup: IResponseFilterSmartView[]) => {
  const filtersGroupFormatted = toJS(filtersGroup)

  const filtersGroupDataBase = filtersGroupFormatted.map((filterGroup) => {
    return filterGroup.filters.map((filter) => {
      const value = Array.isArray(filter.value) ? filter.value.map((i) => Number(i)) : []
      const operator = filter.operator
      const key = filter.key
      const itemValue = getValueByKey(key, data)

      switch (operator) {
        case 'is_any':
          return value.some((v) => itemValue.includes(v))

        case 'is_none':
          return !value.some((v) => itemValue.includes(v))

        case 'is_known':
          return Boolean(itemValue.length)

        case 'is_unknown':
          return !Boolean(itemValue.length)

        case 'is_equal_to_all':
          return value.length === itemValue.length && value.every((v) => itemValue.includes(v))

        case 'is_not_equal_all':
          return value.length === itemValue.length && !value.every((v) => itemValue.includes(v))

        case 'contains_all':
          return value.every((v) => itemValue.includes(v))

        case 'not_contain_all':
          return !value.every((v) => itemValue.includes(v))

        default:
          return true
      }
    })
  })

  const filtersGroupDataOR = filtersGroupDataBase.map((item) => item.every((b) => b))
  const filtersGroupDataFinish = filtersGroupDataOR.some((item) => item)

  return filtersGroupDataFinish
}
